import React from "react";
import { connect } from "react-redux";
import { SplashContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
import { ROOM_BOOKING_PAYMENT_PATH } from "utils/functions/roomBooking";
import { userService } from "apiServices";
import queryString from "query-string";
import { toast } from "react-toastify";
import { setReduxAuthen } from "store/reducers/authenReducer";
import { setReduxWallet } from "store/reducers/walletReducer";
import liff from "@line/liff";
import { initLiff } from "utils/functions/scanQR";
import { Displays } from "components";

class SplashContainer extends React.Component {
  state = {
    // debugLogs: []
  };

  componentDidMount() {
    // เก็บ redirect params ไว้ใน localStorage (เผื่อหายตอน redirect ข้าม domain)
    // room ใช้กับ redirect=room-booking-payment (ลิงก์ปุ่มอัพโหลดสลิปในอีเมล)
    const { redirect, id, room } = queryString.parse(
      this.props.router.location.search,
    );
    if (redirect) {
      sessionStorage.setItem(
        "pendingRedirect",
        JSON.stringify({ redirect, id, room }),
      );
    }

    // เรียก liff.init() เสมอเพื่อรองรับทุก flow:
    // 1. LIFF browser (liff.line.me) → init auto-login → isLoggedIn = true
    // 2. Redirect กลับจาก liff.login() (?code=...) → init แลก code → isLoggedIn = true
    // 3. เปิดตรง (ไม่มี LIFF context) → init สำเร็จ → isLoggedIn = false → ไปหน้า login
    this.handleInit();
  }

  isTokenExpired = () => {
    try {
      const idToken = liff.getDecodedIDToken();
      if (!idToken || !idToken.exp) return true;
      // exp เป็น unix timestamp (วินาที) — เช็คว่าหมดอายุหรือยัง (เผื่อ buffer 60 วินาที)
      return idToken.exp * 1000 < Date.now() - 60000;
    } catch {
      return true;
    }
  };

  // log = (msg) => {
  //   this.setState((prev) => ({
  //     debugLogs: [
  //       ...prev.debugLogs,
  //       `${new Date().toLocaleTimeString()} ${msg}`,
  //     ],
  //   }));
  // };

  handleInit = async () => {
    const initOk = await initLiff()
      .then(() => true)
      .catch((err) => {
        console.error("LIFF init failed:", err);
        return false;
      });

    // this.log(`initOk: ${initOk}`);
    // if (initOk) {
    //   this.log(`isLoggedIn: ${liff.isLoggedIn()}`);
    //   this.log(`isInClient: ${liff.isInClient()}`);
    //   this.log(`isTokenExpired: ${this.isTokenExpired()}`);
    //   this.log(`userAgent: ${navigator.userAgent}`);
    // }

    if (!initOk) {
      // this.log("→ LOGIN (init failed)");
      this.props.router.navigate(ROUTE_PATH.LOGIN);
    } else if (liff.isLoggedIn() && !this.isTokenExpired()) {
      // this.log("→ handleLineLoginSuccess");
      this.handleLineLoginSuccess();
    } else if (liff.isInClient() || /Line/i.test(navigator.userAgent)) {
      // this.log("→ liff.login()");
      liff.login();
    } else {
      // this.log("→ LOGIN (external, no session)");
      this.props.router.navigate(ROUTE_PATH.LOGIN);
    }
  };

  handleLineLoginSuccess = async () => {
    try {
      const accessToken = liff.getAccessToken();
      const profile = await liff.getProfile();
      const res = await userService.POST_LINE_LOGIN({
        access_token: accessToken,
      });
      // this.log(`accessToken: ${accessToken}`);
      // this.log(`profile: ${JSON.stringify(profile)}`);
      // this.log(`res: ${JSON.stringify(res)}`);
      if (res && res.status === 200) {
        localStorage.setItem("token", res.token);
        this.fetchMyInfomation();
      } else if (res && res.data?.lineRefID) {
        const lineRefID = res.data?.lineRefID;
        this.props.router.navigate(
          `${ROUTE_PATH.PRE_REGISTER}?is_regis=true&lineID=${lineRefID}&avatar=${encodeURIComponent(profile?.pictureUrl || "")}`,
        );
      } else if (res) {
        toast.error(res?.data?.error?.message || "LINE login failed");
        // เฉพาะ external browser เท่านั้นที่ logout — ใน LIFF browser ห้าม logout เพราะจะทำให้ auto-login พัง
        if (!liff.isInClient()) liff.logout();
        this.props.router.navigate(ROUTE_PATH.LOGIN);
      }
    } catch (err) {
      console.error("LINE login error:", err);
      if (!liff.isInClient()) liff.logout();
      toast.error("เข้าสู่ระบบผ่าน LINE ไม่สำเร็จ กรุณาลองใหม่");
      this.props.router.navigate(ROUTE_PATH.LOGIN);
    }
  };

  fetchMyInfomation = async () => {
    let { page, redirect, id, room } = queryString.parse(
      this.props.router.location.search,
    );
    if (!redirect) {
      const pendingRedirect = sessionStorage.getItem("pendingRedirect");
      if (pendingRedirect) {
        try {
          const parsed = JSON.parse(pendingRedirect);
          redirect = parsed.redirect;
          id = parsed.id;
          room = parsed.room;
        } catch (e) {
          // ignore
        }
      }
    }
    sessionStorage.removeItem("pendingRedirect");

    try {
      let resArr = await Promise.all([
        userService.GET_MY_PROFILE(),
        userService.GET_MY_WALLET(),
      ]);
      if (resArr) {
        this.props.setReduxAuthen(resArr[0].data);
        this.props.setReduxWallet(resArr[1].data);
        if (!redirect) {
          this.props.router.navigate(
            !page ? ROUTE_PATH.HOME : ROUTE_PATH[page],
          );
        } else {
          switch (redirect) {
            case "activity":
              this.props.router.navigate(`${ROUTE_PATH.ACTIVITIES}/${id}`);
              break;
            case "online-form":
              this.props.router.navigate(`${ROUTE_PATH.ACTIVITY_FORM}/${id}`);
              break;
            case "activity-qr-register":
              this.props.router.navigate(
                `${ROUTE_PATH.ACTIVITIES}/${id}/qr-register`,
              );
              break;
            case "room-booking-payment":
              this.props.router.navigate(
                ROOM_BOOKING_PAYMENT_PATH({ id, room }),
              );
              break;
            default:
              this.props.router.navigate(ROUTE_PATH.HOME);
              break;
          }
        }
      }
    } catch (err) {
      console.error("Fetch user info failed:", err);
      toast.error("โหลดข้อมูลผู้ใช้ไม่สำเร็จ กรุณาลองใหม่");
      localStorage.removeItem("token");
      this.props.router.navigate(ROUTE_PATH.LOGIN);
    }
  };

  render() {
    // const { debugLogs } = this.state;
    return (
      <SplashContainerStyled>
        <Displays.Loading />
        {/* {debugLogs.length > 0 && (
          <div
            style={{
              position: "fixed",
              bottom: 0,
              left: 0,
              right: 0,
              background: "rgba(0,0,0,0.85)",
              color: "#0f0",
              fontSize: 11,
              padding: 8,
              maxHeight: "40vh",
              overflow: "auto",
              zIndex: 9999,
              fontFamily: "monospace",
              whiteSpace: "pre-wrap",
            }}
          >
            {debugLogs.map((log, i) => (
              <div key={i}>{log}</div>
            ))}
          </div>
        )}  */}
      </SplashContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({
  setReduxAuthen: (data) => dispatch(setReduxAuthen(data)),
  setReduxWallet: (data) => dispatch(setReduxWallet(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(SplashContainer));
